import { now } from "lodash";
import React, { useState, useEffect, memo, FC } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import Loading from "../../../ui/Loading";
import ReportApi from "../../restapi/reportApi";
import store from "../../store";
import RenderBaoCaoLaiLo from "./renderBaoCaoLaiLo";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import { ContactsApi } from "../../restapi/contactsApi";
import { sleep } from "../../../../lib/gramjs/Helpers";
import worker from "../../setupWorker";

type OwnProps = {

}

const BaoCaoDoanhThu: FC<OwnProps> = ({

}) => {
    const [state, setState] = useState({
        tuNgay: store.getState().global.workDate,
        denNgay: store.getState().global.workDate,
        isLoading: true,
        data: [],
        trigger: now(),
        isConfirmOpen: false,
    })
    useEffect(() => {
        const payload = { tuNgay: state.tuNgay, denNgay: state.denNgay }
        setState(prev => ({ ...prev, isLoading: true }))
        ReportApi.getBaoCaoDoanhThu(payload).then(res => {
            setState(prev => ({ ...prev, isLoading: false, data: res.data }))
        })
    }, [state.trigger])
    async function handleSaveCongNo() {
        setState(prev => ({ ...prev, isConfirmOpen: false }))
        const res = await ContactsApi.getCongNoDateRangeForSave()
        const dates: string[] = res.data
        const length = dates.length
        let text = `đang thực hiện 1/${length}`
        let i = 1;
        for (let date of dates) {
            const payload = { ngay: date.substring(0, 10) }
            text = `đang thực hiện ${i}/${length}`
            worker.postMessage({ type: 'showsnackbar', data: text })
            await ReportApi.saveCongNoNgay(payload).then(response => {
                //console.log(response)
            })
            await sleep(200)
            i++
        }
        worker.postMessage({ type: 'showsnackbar', data: "Đã lưu xong toàn bộ công nợ" })
    }
    return <div className=" form-content">
        <div className=" common-container-row">
            <input className=" date-input" type="date" value={state.tuNgay}
                onChange={(e) => {
                    setState(prev => ({ ...prev, tuNgay: e.target.value }))
                }}
            />
            <div>đến ngày</div>
            <input className=" date-input" type="date" value={state.denNgay}
                onChange={(e) => {
                    setState(prev => ({ ...prev, denNgay: e.target.value }))
                }}
            />
            <Button round size="tiny"
                onClick={() => setState(prev => ({ ...prev, trigger: now() }))}
            >
                <i className=" icon icon-reload"></i>
            </Button>
        </div>
        {
            state.isLoading ? <Loading /> : <RenderBaoCaoLaiLo data={state.data}></RenderBaoCaoLaiLo>
        }
        <div>Mỗi ngày bạn cần lưu sổ công nợ (Báo cáo lãi lỗ ngày) để có dữ liệu đầy đủ</div>
        <div className=" common-container-row pading-top" >
            <Button size="tiny" onClick={() => setState(prev => ({ ...prev, isConfirmOpen: true }))}>Lưu lại toàn bộ công nợ</Button>
        </div>
        <ConfirmDialog isOpen={state.isConfirmOpen}
            title="Xác nhận"
            text={`Lưu lại toàn bộ số liệu công nợ phát sinh, hệ thống sẽ xoá toàn bộ số liệu
             công nợ phát sinh và tiến hành tính toán lưu lại theo số liệu phân tích từng ngày, nếu bạn đã xoá số liệu phân tích của ngày nào đó
             thì sẽ không có dữ liệu để lưu, bạn hãy cẩn trọng khi thực hiện!!!`}
            confirmLabel="Đồng ý"
            confirmHandler={() => {
                handleSaveCongNo()
            }}
            onClose={() => {
                setState(prev => ({ ...prev, isConfirmOpen: false }))
            }}
        >

        </ConfirmDialog>
    </div>
}

export default memo(BaoCaoDoanhThu)